export default __webpack_public_path__ + "static/media/2.bc164bd2.png";